import React, { FC, memo } from "react";
import { useMedia } from "react-use";

import { MEDIA_SIZE_SM } from "@/core/media";
import { IWOConfirmTask, WOConfirmTaskActionType } from "@/data/tasks/types";
import { Flex } from "@/eworkitComponents/index";
import { WorkOrderDetailsSections } from "@/views/components/WorkOrder";

import { ActOnBehalfMessage } from "../ActOnBehalfMessage";
import { WOCHeader } from "../WOCHeader";

export interface IWOCDetailsProps {
  task: IWOConfirmTask;
  onAction?: (actionType: WOConfirmTaskActionType, comment: string, task: IWOConfirmTask) => void;
}

export const WOCDetails: FC<IWOCDetailsProps> = memo(({ task, onAction }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Flex width={12} direction="column">
      <ActOnBehalfMessage
        task={task}
        margin={isSmallScreen ? [false, "md", "md", "md"] : [false, false, "md", false]}
      />

      <Flex width={12} direction="column" innerMargin="md">
        <WOCHeader task={task} onAction={onAction} />

        <WorkOrderDetailsSections workOrder={task.entity} externalAttachments={task.externalAttachments} />
      </Flex>
    </Flex>
  );
});
